// hooks/table/configs/useSelectProductOnSupplierProduct.ts
import { useState } from 'react';
import { FormikProps } from 'formik';

import { useProductsSelectTable } from './useProductsTable';          // ← your existing selector-grid config
import { useTableSelector, MergeResult } from '../tableSettings/useTableSelector';

type ProductRow = any;                                               // type it properly in your code

export function useSelectProductOnSupplierProduct<FormValues>(
  formik: FormikProps<FormValues>,
) {
  
  const [selCols, selSettings] = useProductsSelectTable();

  
  const [rows, setRows] = useState<ProductRow[]>([]);

  const productOptions: ProductRow[] = selSettings?.allRows ?? [];

  
  const onMerge = (
    _: ProductRow[],
    picked: ProductRow[],
  ): MergeResult<ProductRow> => {
    const p = picked[0];
    if (p) {
      const { setFieldValue } = formik;   // ⇦ less noisy than passing it in
      setFieldValue('Product',                p.ProductId                 ?? '');
      setFieldValue('Manufacturer',           p.Manufacturer?.Key         ?? '');
      setFieldValue('ManufacturerProduct',    p.ManufacturerProductId     ?? '');
      setFieldValue('ManufacturerProduct_Value',
                                              p.ManufacturerProduct?.Value?? '');
      setFieldValue('ProductType',            p.ProductType?.Value        ?? '');
      setFieldValue('ProductStatus',          p.ProductStatus?.Key        ?? '');
    }
    return { rows, keepOpen: false };  // nothing to store – just close
  };

 
  const selector = useTableSelector<ProductRow>({
    rows,
    setRows,
    selectGrid: [selCols, selSettings],
    getId: row => row.ProductId,
    onMerge,
  });

  return {
    ...selector,
    productOptions,
  };   
}